import {
  Card,
  CardMedia,
  Typography,
  List,
  styled,
  Modal,
} from '@mui/material';
import { SwiperSlide } from 'swiper/react';

import { multilineEllipsisOverflow } from 'theSource/utils';

export const CardStyled = styled(Card)(({ theme }) => ({
  maxWidth: '100%',
  boxShadow: theme.customShadow,
}));

export const CardMediaStyled = styled(CardMedia)(({ theme }) => ({
  height: theme.spacing(35),
})) as typeof CardMedia;

export const CardTextStyled = styled(Typography)(({ theme }) => ({
  height: theme.spacing(15),
  maxHeight: theme.spacing(15),
  ...multilineEllipsisOverflow(3),
})) as typeof Typography;

export const SwiperSlideStyled = styled(SwiperSlide)(({ theme }) => ({
  padding: theme.spacing(3, 0),
})) as typeof SwiperSlide;

export const H2Truncated = styled(Typography)(({ theme }) => ({
  height: theme.spacing(6),
  maxHeight: theme.spacing(6),
  ...multilineEllipsisOverflow(1),
})) as typeof Typography;

export const CardDocListStyled = styled('ul')(({ theme }) => ({
  display: 'block',
  '& li': {
    color: `${theme.palette.primary.main} !important`,
    '& a': {
      textDecoration: 'none !important',
      color: 'inherit',
    },
  },
  ...multilineEllipsisOverflow(3),
})) as typeof List;

export const CardDocListWrapper = styled('div')(({ theme }) => ({
  height: theme.spacing(15),
  maxHeight: theme.spacing(15),
}));

export const ModalStyled = styled(Modal)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto',
  '& .modal-content-wrapper': {
    backgroundColor: theme.palette.primaryLight.main,
  },
}));
